export default __webpack_public_path__ + "static/media/pic15.515e87e4.jpg";